interface CircleProps {
  size?: number;
  color?: string;
  activeColor?: string;
  isSelected?: boolean;
}

const Circle = ({
  size = 22,
  color = "#b4bac3",
  activeColor = "#007AF5",
  isSelected,
}: CircleProps) => {
  const style = {
    width: size,
    height: size,
    borderRadius: size / 2,
    borderColor: isSelected ? activeColor : color,
    borderWidth: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const innerSize = Math.floor(size / 2);

  const innerStyle = {
    width: innerSize,
    height: innerSize,
    borderRadius: innerSize / 2,
    borderColor: activeColor,
    backgroundColor: activeColor,
    borderWidth: 1,
  };

  return <div style={style}>{isSelected && <div style={innerStyle} />}</div>;
};

export default Circle;
